import React, { Component } from 'react'
import { Form, FormControl, InputGroup } from 'react-bootstrap';
import Modal from "react-modal";
import { CgCheckO } from 'react-icons/cg';
import { connect } from 'react-redux'
import BackButton from '../../../elements/BackButton';
import { sentFeedback } from '../../../redux/Parent/user/action';
import { getStudentAppointmentDetails } from "../../../redux/Parent/appointment/action";
import Select from "react-select";
import { AiFillStar } from 'react-icons/ai';

export class Feedback extends Component {

    state = {
        open: false,
        feedback: "",
        rating: 5,
        schoolFeedback: "",
        selectedTeacher: "",
        teacherId: null,
    }
    componentDidMount() {
        const { user } = this.props;
        let student_id = JSON.parse(localStorage.getItem("student_id"));
        if (student_id) {
            this.props.getStudentAppointmentDetails(
                user.data.auth_token,
                student_id.value
            );
        }
    }
    handleInput = (e) => {
        this.setState({ feedback: e });
    }
    handleSchoolInput = (e) => {
        this.setState({ schoolFeedback: e.target.value });
    }
    handleTeacher = (selectedTeacher) => {
        this.setState({ selectedTeacher, teacherId: selectedTeacher.value });
    }
    onSubmit = (e) => {
        e.preventDefault();
        const { user } = this.props;
        let student_id = JSON.parse(localStorage.getItem("student_id"));

        let formdata = new FormData();
        formdata.append("student_id", student_id?.value || 1);
        formdata.append('token', user.data.auth_token);
        formdata.append("teacher_id", this.state.teacherId);
        formdata.append("feedback", this.state.feedback);
        formdata.append("rating", this.state.rating);
        formdata.append("type", "TEACHER");

        this.props.sentFeedback(formdata).then((response) => {
            if (response.data?.success) {
                this.modalOpen();
                this.setState({ feedback: "", selectedTeacher: "", teacherId: null, rating: 5 });
            } else {
                console.log("Something went wrong");
            }
        });
    }

    modalOpen = () => {
        this.setState({ open: true });
    };

    modalClose = () => {
        this.setState({ open: false });
    };

    render() {
        let student_id = JSON.parse(localStorage.getItem("student_id"));
        const { makeAppointment } = this.props;

        const teachers = makeAppointment?.staffs?.map((sub) => ({
            value: sub.id, label: sub.user?.name
        }))

        return (
            <React.Fragment>
                <BackButton title={"Feedback"} />
                <Form onSubmit={this.onSubmit}>
                    <div className='px-3 mt-3'>
                        <div className="mt-2">
                            <div className="flex-column p-1">
                                <div className="d-flex justify-content-between mt-2 homework-input">
                                    <div className="text-muted"> Student </div>
                                    <div style={{ fontWeight: "600" }}>
                                        {student_id?.label || "Student"}
                                    </div>
                                </div>
                            </div>
                            <div className="flex-column p-1">
                                <div className="pt-2">
                                    <Select
                                        className="text-muted"
                                        styles={customStyles}
                                        placeholder="Select Teacher"
                                        options={teachers}
                                        value={this.state.selectedTeacher}
                                        onChange={this.handleTeacher}
                                        required
                                    />
                                </div>
                            </div>

                            {/* Star Rating Input */}
                            <div className="flex-column p-1 mt-2">
                                <div className="text-muted mb-1" style={{ fontSize: "14px", fontWeight: "500" }}>
                                    Rating (1 to 5 Stars)
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <AiFillStar
                                            key={star}
                                            size={32}
                                            style={{
                                                cursor: "pointer",
                                                color: star <= this.state.rating ? "#FFC107" : "#E4E6EB",
                                                transition: "color 0.15s ease",
                                            }}
                                            onClick={() => this.setState({ rating: star })}
                                        />
                                    ))}
                                    <span className="ms-2 fw-bold" style={{ fontSize: "16px", color: "#c1486f" }}>
                                        {this.state.rating} / 5
                                    </span>
                                </div>
                            </div>

                            <InputGroup hasValidation className="mt-3" style={{ boxSizing: 'border-box' }} >
                                <FormControl
                                    type="text"
                                    placeholder="Write your feedback..."
                                    className="attendence-input"
                                    value={this.state.feedback}
                                    onChange={e => {
                                        let value = e.target.value;
                                        this.handleInput(value);
                                    }}
                                    required
                                />
                            </InputGroup>
                        </div>
                    </div>
                    <div className='py-3 w-100 px-3'>
                        <button className='btn attendence-dwld-btn py-3 w-100' style={{ backgroundColor: "#c1486f", borderColor: "#c1486f" }}>
                            Submit Feedback
                        </button>
                    </div>
                </Form>

                {/* 
                School Feedback Form - Commented Out
                <Form onSubmit={this.onSchoolFormSubmit}>
                    ...
                </Form>
                */}

                <Modal
                    isOpen={this.state.open}
                    ariaHideApp={false}
                    onRequestClose={() => this.modalClose()}
                    style={modalStyles}
                    contentLabel="Success Modal"
                >
                    <div
                        className="container"
                        style={{
                            borderRadius: "5px",
                            height: "70vw",
                            width: '70vw',
                            zIndex: "9999",
                        }}
                    >
                        <React.Fragment>
                            <div className="d-flex flex-column justify-content-center align-items-between">
                                <div className='d-flex justify-content-center mt-5'
                                    style={{ fontSize: '18px', fontWeight: '600', color: '#2B2C2F' }}>
                                    <CgCheckO color={"#7ECB40"} size={"4em"} />
                                </div>
                                <div className='d-flex justify-content-center mt-4'
                                    style={{ fontSize: '15px', fontWeight: '400', color: '#2B2C2F' }}>
                                    Feedback Added Successfully</div>
                            </div>
                        </React.Fragment>
                    </div>
                </Modal>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    user: state.user.parent,
    makeAppointment: state.appointment.makeAppointment
})

export default connect(mapStateToProps, { sentFeedback, getStudentAppointmentDetails })(Feedback)

const modalStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-38%",
        border: "2px solid #C24A6B",
        transform: "translate(-50%, -50%)",
        borderRadius: "15px",
    },
};

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: "#fff",
        border: "none", // tried border: 'none'
        boxShadow: "none", // tried border: 'none'
        outline: "none",
    }),
    control: (provided) => ({
        ...provided,
        height: "45px",
        border: "none",
        boarderRadius: "10px",
        fontSize: "13px",
        borderStyle: "none",
        backgroundColor: "rgba(190, 175, 179, 0.05)",
        outline: "none",
        boxShadow: "0px 0px 12px rgba(0, 0, 0, 0.02) inset",
        shadowOpacity: 0.5,
        shadowRadius: 50,
    }),
};
